import React from "react"
import { GridColDef } from "@mui/x-data-grid-pro"

import { IColumnsOrder, ColumnsState, IColumnsVisibility, ITableColumn } from "./state"

type SDT = React.Dispatch<React.SetStateAction<ColumnsState>>

export interface IColumnsApi {
  setState: SDT;
  setCombined: (value: ITableColumn[]) => void;
  setOrder: (value: IColumnsOrder) => void;
  setVisible: (value: IColumnsVisibility) => void;
  updateVisible: (value: IColumnsVisibility) => void;
  setCustomizable: (value: ITableColumn[]) => void;
  setDefinitions: (value: GridColDef[]) => void;
}

export const initApi = (setState_: SDT): IColumnsApi => {

  const setState = setState_

  const setCombined = (value: ITableColumn[]) => {
    setState_((state) => ({
      ...state,
      combinedColumns: value
    }))
  }

  const setOrder = (value: IColumnsOrder) => {
    setState_((state) => ({
      ...state,
      order: value
    }))
  }

  const setVisible = (value: IColumnsVisibility) => {
    setState_((state) => ({
      ...state,
      visibility: value
    }))
  }

  const updateVisible = (value: IColumnsVisibility) => {
    setState_((state) => ({
      ...state,
      visibility: {
        ...state.visibility,
        ...value
      }
    }))
  }

  const setCustomizable = (value: ITableColumn[]) => {
    setState_((state) => ({
      ...state,
      customizableColumns: value
    }))
  }

  const setDefinitions = (value: GridColDef[]) => {
    setState_((state) => ({
      ...state,
      columnDefinitions: value
    }))
  }

  return {
    setState,
    setCombined,
    setOrder,
    setVisible,
    updateVisible,
    setCustomizable,
    setDefinitions,
  }
}
